export const announcementReference = number => number ? `ANN-${String(number).padStart(6, '0')}` : 'Sans numéro';
